import { Flex, Icon } from '@chakra-ui/react';
import { ChevronDown, ChevronUp } from '../chevron';

export const Sort = ({
  onChange = () => {},
  direction = 'default',
  ...props
}) => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      rowGap="2px"
      onClick={() => {
        switch (direction) {
          case 'desc':
            onChange('asc');
            break;

          case 'asc':
            onChange('default');
            break;

          default:
            onChange('desc');
            break;
        }
      }}
      {...props}
    >
      {direction !== 'desc' ? <Icon as={ChevronUp} /> : null}
      {direction !== 'asc' ? <Icon as={ChevronDown} /> : null}
    </Flex>
  );
};
